import { UAParser } from 'ua-parser-js';

export type PlatformType = 'mobile' | 'desktop' | 'app';
export type SourceType = 'mobile' | 'desktop' | 'tablet';

export const platformMap: { [id: string]: PlatformType } = {
  mobile: 'mobile',
  desktop: 'desktop',
  tablet: 'desktop'
};

export const getPlatformBySource = (
  source: SourceType,
  isWebView: boolean
): PlatformType => (isWebView ? 'app' : platformMap[source]);

export const getSourceFromUA = (userAgent: string | undefined): SourceType => {
  const defaultSSRPlatform: SourceType = 'desktop';

  if (userAgent) {
    const parser = new UAParser(userAgent);

    const deviceType = parser.getDevice().type;

    if (deviceType === 'mobile') return 'mobile';
    if (deviceType === 'tablet') return 'tablet';
  }

  return defaultSSRPlatform;
};

export const getXPlatform = (ssrPlatform: PlatformType): PlatformType => {
  const isBrowser = typeof window !== 'undefined';

  if (!isBrowser && ssrPlatform) return ssrPlatform;

  if (isBrowser)
    return getPlatformBySource(
      getSourceFromUA(navigator.userAgent),
      !!window.ReactNativeWebView
    );
  return 'mobile';
};

export function getLogSource<
  T extends Record<'App' | 'Desktop' | 'Mobile', string>
>(enumType: T, sourceType: SourceType, isWebView: boolean): T[keyof T] {
  if (isWebView) return enumType.App;

  switch (sourceType) {
    case 'tablet':
    case 'desktop':
      return enumType.Desktop;
    case 'mobile':
      return enumType.Mobile;
    default:
      return enumType.Desktop;
  }
}
